// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ok35","title":"styles_title__TiEUU"};